exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pdf-link{margin:10px;background-color:rgba(226,64,64,0.9);border-radius:4px;color:#fff\n}\n.pdf-link:hover{background-color:#e24040;color:#fff\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5d253742","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/pages/AcoperisExpert.vue
// module id = 55
// module chunks = 0